import React from "react";
import PropTypes from "prop-types";
import { fieldType } from "../../constants";


function Input(Props) {
  const {
    type,
    className,
    preIconClass,
    postIconClass,
    postTextClass,
    placeholder,
    handleChange,
    onIconClick,
    name,
    value,
    title,
    pattern,
    onFocus,
    alt,
    readOnly,
    required,
    onKeyDown,
    min,
    max,
  } = Props;

  const getMaxLength = () => {
    if(name === 'pancardNumber') {
      return 10;
    } else if (name === 'GSTNumber') {
      return 15;
    } 
    return fieldType[type] ?? null
  }

  return (
      <div>
        {preIconClass && (
          <span className={value ? "input_pre-active" : "input_pre"}>
            <img src={preIconClass} alt={alt} />
          </span>
        )}
        <input
          type={type === "otp" ? "tel" : type}
          name={name}
          className={className}
          value={value}
          id={name}
          placeholder={placeholder}
          onChange={handleChange}
          key={name}
          maxLength={getMaxLength()}
          minLength={getMaxLength()}
          onFocus={onFocus}
          pattern={pattern}
          title={title}
          disabled={readOnly}
          required={required}
          onKeyDown={onKeyDown}
          min={min}
          max={max}
          // onMouseEnter={onMouseEnter}
        />
        
        {postTextClass && (
          <div className="input_post link"  onClick={onIconClick} dangerouslySetInnerHTML={{__html:postTextClass }}/>
          //   {postTextClass}
          // </p>
        )}
        {postIconClass && (
          <span className="input_post" onClick={onIconClick}>
            <img src={postIconClass} alt={alt} />
          </span>
        )}
      </div>
  );
}

Input.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  preIconClass: PropTypes.string,
  postIconClass: PropTypes.string,
  labelClass: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  pattern: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleChange: PropTypes.func,
  onIconClick: PropTypes.func,
  onFocus: PropTypes.func,
  readOnly: PropTypes.oneOfType([PropTypes.string,PropTypes.bool]),
  required: PropTypes.oneOfType([PropTypes.string,PropTypes.bool]),
  alt: PropTypes.string,
  onKeyDown: PropTypes.func,
  labelIcon: PropTypes.string,
  postTextClass:PropTypes.string,
  min:PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max:PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Input.defaultProps = {
  type: "text",
  className: "form-control grey-input with_icon",
  preIconClass: "",
  postIconClass: "",
  label: "label",
  placeholder: "",
  handleChange: () => null,
  onIconClick: () => null,
  name: "",
  labelClass: "hidden",
  value: "",
  alt: "no-img",
  pattern: null,
  title: null,
  readOnly: false,
  required: false,
  onFocus: () => null,
  onKeyDown: () => null,
  labelIcon: "",
  errors: "",
  propTypes:"",
  onMouseEnter:()=>null,
  min:null,
  max:null,
};

export default Input;
